export const getStyles = () => {
    const styles = {
        avatar: { 
            width: '180px', 
            height: '180px', 
            // cursor: 'pointer' 
        }
    };
    return styles;
};